import React from 'react'

import {Paper, useTheme} from "@mui/material";

import {whiteBackgroundColor} from "../../../constants"
import Grid from "@mui/material/Grid2"

import {PlanDescriptionSection} from "./PlanDescriptionSection"
import {CompositionElevationViewSection} from "./CompositionElevationViewSection"
import {useSelector} from "react-redux"
import {LidGroundViewSection} from "./LidGroundViewSection"
import {IntermediateCeilingGroundViewSection} from "./IntermediateCeilingGroundViewSection"
import {FloorGroundViewSection} from "./FloorGroundViewSection"
import {validatePlan} from "../../../validation/vault/messages/validation";
import {Alerts} from "../../Alerts"

export const VerificationStep = () => {
    const theme = useTheme()
    const plan = useSelector(state => state.plan)
    const hasManholes = plan.lid?.manholes.length > 0 ?? false
    const errors = validatePlan(plan)

    return (
        <Grid container spacing={1}>
        {errors && errors.length > 0 && <Paper square={true} sx={{
            background: whiteBackgroundColor, padding: theme.spacing(6), width: '100%',
        }}
        >
            <Grid container spacing={6} size={12}>
                {errors && errors.length > 0 && <Alerts errors={errors}/>}
            </Grid>
        </Paper>}

        <Paper square={true} sx={{
            background: whiteBackgroundColor, padding: theme.spacing(6)
        }}>
            <Grid container spacing={6}>
                <Grid size={12}>
                    <PlanDescriptionSection/>
                </Grid>
                {!!plan.lid && !(plan.lid.collar === 'without' && !hasManholes) && <Grid size={12}>
                    <LidGroundViewSection/>
                </Grid>}
                {!!plan.intermediateCeiling && !plan.lid && <Grid size={12}>
                    <IntermediateCeilingGroundViewSection/>
                </Grid>}
                {(!!plan.floor) && <Grid size={12}>
                    <FloorGroundViewSection/>
                </Grid>}
                {(!!plan.lid || !!plan.intermediateCeiling || !!plan.vault || !!plan.floor) && <React.Fragment>
                    <Grid size={12}>
                        <CompositionElevationViewSection wallIndex={0}/>
                    </Grid>
                    <Grid size={12}>
                        <CompositionElevationViewSection wallIndex={1}/>
                    </Grid>
                    <Grid size={12}>
                        <CompositionElevationViewSection wallIndex={2}/>
                    </Grid>
                    <Grid size={12}>
                        <CompositionElevationViewSection wallIndex={3}/>
                    </Grid>
                </React.Fragment>}
            </Grid>
        </Paper>
    </Grid>
    )
}

